import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ProviderShell from "./ProviderShell";
import Router from "./routes/Router";
import "./global.css";
var Application = function () {
    return (_jsx(ProviderShell, { children: _jsx(Router, {}) }));
};
export default Application;
